import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import SendPushNotification from './SendPushNotification'

export default function PushNotifications() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/push_notifications" component={SendPushNotification} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}